/* Publish by EComposer at 2025-08-04 22:05:01*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ykes52llvxd"]=  window.__ectimmers["ecom-ykes52llvxd"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ykes52llvxd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ykes52llvxd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0rl89wcy7e1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0rl89wcy7e1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l61h2cneq9d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l61h2cneq9d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oqzpz4ora1r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oqzpz4ora1r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hvz96hie62o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hvz96hie62o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yttqm7nc2vr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yttqm7nc2vr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-su2yj9rupbk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-su2yj9rupbk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ieqh7dt3gx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ieqh7dt3gx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d8o0azd5998').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d8o0azd5998', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dnawzdmdwj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dnawzdmdwj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cm0lm000br9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cm0lm000br9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v6plunzr3jf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v6plunzr3jf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8853z8skguj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8853z8skguj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fyre74vsxd9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fyre74vsxd9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xdtb91sir0h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xdtb91sir0h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-acjpzotwlrh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-acjpzotwlrh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jf9zxbpg1hs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jf9zxbpg1hs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q72igh4zxqs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q72igh4zxqs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-txiv2ka9ylj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-txiv2ka9ylj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5s4l75ykdxa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5s4l75ykdxa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gbo0libilpu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gbo0libilpu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i1ywummbgsk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i1ywummbgsk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j06eh0ratwj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j06eh0ratwj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c5hpx48tmv7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c5hpx48tmv7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ikhipteofv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ikhipteofv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rvfe59aswmc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rvfe59aswmc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-72mq10baf6x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-72mq10baf6x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qyjy33dqhgh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qyjy33dqhgh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ebanflzih1t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ebanflzih1t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4nv1dewqqo9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4nv1dewqqo9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xp31kkw0pd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xp31kkw0pd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-foe6gzhp8mr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-foe6gzhp8mr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qfl12eerkuo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qfl12eerkuo', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mt40nqqzt8g"]=  window.__ectimmers["ecom-mt40nqqzt8g"] || {};
var g,b,u,x,$,v;let e=this.$el;if(!e)return;let i=this.isLive;const t=(g=this.settings.disable_auto_close)!=null?g:!1,n=(b=this.settings.disable_auto_close__tablet)!=null?b:!1,s=(u=this.settings.disable_auto_close__mobile)!=null?u:!1,o=(x=this.settings.scroll_on_mobile)!=null?x:!1,a=($=this.settings.disable_effect)!=null?$:!1,r=(v=this.settings.close_all)!=null?v:!1,c=e.querySelectorAll(".ecom-accordion__item > .ecom-accordion__title");function m(w){const f=w.getBoundingClientRect();return f.top>=0&&f.left>=0&&f.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&f.right<=(window.innerWidth||document.documentElement.clientWidth)}function l(w){let f=window.screen.width;window.EComposer.TEMPLATE_ID||(f=window.innerWidth),w.forEach((k,L)=>{let z=k.parentNode.querySelector(".ecom-accordion__body");!a&&z&&z.classList.add("ecom-effect-accodion"),L==0&&(z.style.height=z.clientHeight+"px"),k.onclick=function(M){M.preventDefault();let T=this.parentNode,S=T.parentNode;const q=S.querySelectorAll(".ecom-accordion__item"),P=S.querySelectorAll(".ecom-accordion__title");if(T.classList&&T.classList.remove("ecom-item-group-init"),this.classList&&this.classList.contains("ecom-item-active"))s&&f<768||n&&f>767&&f<1025||t&&f>1024?(this.classList.remove("ecom-item-active"),T.querySelector(".ecom-accordion__body").style.height="0px",T.querySelector(".ecom-accordion__title").classList.remove("ecom-item-active"),T.classList.remove("ecom-item-active")):(q.forEach(D=>h(D)),P.forEach(D=>D.classList.remove("ecom-item-active")));else{s&&f<768||n&&f>767&&f<1025||t&&f>1024||(q.forEach(N=>h(N)),P.forEach(N=>N.classList.remove("ecom-item-active"))),k.classList.add("ecom-item-active"),T.classList.add("ecom-item-active");let D=k.parentNode.querySelector(".ecom-accordion__body");k.parentNode.closest(".ecom-accordion__body")&&(k.parentNode.closest(".ecom-accordion__body").style.height="auto"),D.style.height="auto";let W="auto";a||(W=i?D.clientHeight+"px":"auto",D.classList.add("ecom-effect-accodion")),D.style.height="0px",setTimeout(()=>{D.style.height=W},10)}window.dispatchEvent(new window.Event("renderScroll")),setTimeout(()=>{window.dispatchEvent(new window.Event("renderScroll")),o?m(this)||R():!m(this)&&f>1024&&R()},50);function A(D){let W=0;if(D.offsetParent){do W+=D.offsetTop;while(D=D.offsetParent);return[W]}}function R(D){window.scrollTo(0,A(e)-100)}}})}function h(w){w.classList.remove("ecom-item-active"),w.querySelector(".ecom-accordion__body").style.height="0"}l(c),r||setTimeout(()=>{e.querySelector(".ecom-item-group-init")&&e.querySelector(".ecom-item-group-init").classList.remove("ecom-item-group-init")},500);function y(){let w=window.location.hash;if(w){let f=e.querySelector(`[data-target="${w}"]`);if(f){f.click();let k=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});f.dispatchEvent(k);let M=f.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,M)}}}setTimeout(function(){y()},300),window.addEventListener("resize",function(){l(c)}),window.addEventListener("hashchange",y,!1)

                    });
                    
                        document.querySelectorAll('.ecom-mt40nqqzt8g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mt40nqqzt8g', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qvsc016a1op').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qvsc016a1op', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jj90tckldh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jj90tckldh', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zlyf1hqw0ws').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zlyf1hqw0ws', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zo3itmvsivb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zo3itmvsivb', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-adlej51twyn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-adlej51twyn', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-me273b6qmbe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-me273b6qmbe', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0qzyzett22').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0qzyzett22', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gk52li16zoo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gk52li16zoo', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-orou4lyoqbh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-orou4lyoqbh', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-81uo09bs8f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-81uo09bs8f', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-icv2zrpnoa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-icv2zrpnoa', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tyrc9gy25d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tyrc9gy25d', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-edgrppuuvwl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-edgrppuuvwl', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3skqhf21m4f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3skqhf21m4f', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uo2r6eztcjs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uo2r6eztcjs', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9m9o6z8atiw"]=  window.__ectimmers["ecom-9m9o6z8atiw"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-9m9o6z8atiw"]["9pavaa6vg"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-9m9o6z8atiw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9m9o6z8atiw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mt7fzf1bk8m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mt7fzf1bk8m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rzlsgyui2h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rzlsgyui2h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z6xd0zgs94a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z6xd0zgs94a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9azfr7dwvbi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9azfr7dwvbi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lo9hbfp8jl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lo9hbfp8jl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9hzh5bze8jt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9hzh5bze8jt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cwtsweq292e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cwtsweq292e', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y14itom69os').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y14itom69os', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kjlv5gqi47b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kjlv5gqi47b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-he36e4ux7uv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-he36e4ux7uv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jp9nmxhgpak').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jp9nmxhgpak', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eexfa1zdozo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eexfa1zdozo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7qu6ddqws8l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7qu6ddqws8l', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w420ky6835r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w420ky6835r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hhoyywhutvb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hhoyywhutvb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mfumdvvttk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfumdvvttk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qhzdjdgt1lb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qhzdjdgt1lb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qp2ucylpxhe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qp2ucylpxhe', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ttxo27ad34n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ttxo27ad34n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b1hvvzaypzl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b1hvvzaypzl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g7p6zrez7re').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g7p6zrez7re', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ds1fmzbnndu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ds1fmzbnndu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ng8e0sbankp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ng8e0sbankp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yg79a0q3x4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yg79a0q3x4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4hk8op54r32').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4hk8op54r32', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g81as55vlpw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g81as55vlpw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9zjzt1784xq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9zjzt1784xq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mywkttp87n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mywkttp87n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r8joit89gps').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r8joit89gps', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xratr5ny4t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xratr5ny4t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-20cfed4sxb9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-20cfed4sxb9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-chgiilnlm4u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-chgiilnlm4u', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b4g25vuhqah').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b4g25vuhqah', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rdn9wwuxnt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rdn9wwuxnt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0qmfnfogdy9g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0qmfnfogdy9g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3npn5gan31u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3npn5gan31u', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iv2ocbc8ian').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iv2ocbc8ian', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4iozd06th5e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4iozd06th5e', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v38w5r1qq1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v38w5r1qq1', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-582ufioqkbq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-582ufioqkbq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x4wymhxrm9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x4wymhxrm9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jnqghxm6c2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jnqghxm6c2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v3scz1q2ha').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v3scz1q2ha', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ss9hogicz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ss9hogicz', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s8d0wodx7nq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s8d0wodx7nq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h49czuw7nla').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h49czuw7nla', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k4okqkdwzco').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k4okqkdwzco', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ha6zl6s1y4t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ha6zl6s1y4t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j54tuzdu12p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j54tuzdu12p', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-310nvq41jh3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-310nvq41jh3', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2agluhjkun6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2agluhjkun6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bbxe597ksdl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bbxe597ksdl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ma5uims8egc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ma5uims8egc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-309q8e7kfrx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-309q8e7kfrx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ibeqhg26srb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ibeqhg26srb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-26lcefcazjkj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-26lcefcazjkj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ezic8641w77').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ezic8641w77', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8gsjfo8uah').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8gsjfo8uah', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-doai1g3e1sc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-doai1g3e1sc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t0sfbany58').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t0sfbany58', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1rlwb0jijfq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1rlwb0jijfq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7yw75nuz6cm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7yw75nuz6cm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l59pp2sa1qc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l59pp2sa1qc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4qsit9lccxf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4qsit9lccxf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vwmoxiompu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vwmoxiompu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f4qmc6u42').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f4qmc6u42', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x26uf1y1zx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x26uf1y1zx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l6t5u6mzt1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l6t5u6mzt1', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ipj0icf2lz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ipj0icf2lz', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cucwp6q8xp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cucwp6q8xp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-glko80omonb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-glko80omonb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ex8wbswozyu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ex8wbswozyu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tly4nzoegzb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tly4nzoegzb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d8d7bia9gvb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d8d7bia9gvb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gh2h24f6l9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gh2h24f6l9r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4l3v3jr4tw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4l3v3jr4tw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wmii62nts5r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wmii62nts5r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2sl5gmfhfts').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2sl5gmfhfts', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hbhjwsw0rm5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hbhjwsw0rm5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0wftaxrpxm8c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0wftaxrpxm8c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-stmk9mg6a2q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-stmk9mg6a2q', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fa52ysnzhlm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fa52ysnzhlm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k5qu9krz2o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k5qu9krz2o', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fntub2xu2sc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fntub2xu2sc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u9brxyqj5xj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u9brxyqj5xj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-exvdsbkeze').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-exvdsbkeze', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ix8h8fsbaw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ix8h8fsbaw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2tubncignj6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2tubncignj6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5pzucf8y4ij').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5pzucf8y4ij', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e7bsox6nycf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e7bsox6nycf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-txdpyi4m71a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-txdpyi4m71a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r3q3j7dse6i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r3q3j7dse6i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e12cxt27kf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e12cxt27kf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lami0tos1q8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lami0tos1q8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xef4vlgfp5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xef4vlgfp5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v8xiyqgcfq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v8xiyqgcfq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gyyp4dwzc58').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gyyp4dwzc58', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iu5cao5rhof').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iu5cao5rhof', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ucidzjkblra').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ucidzjkblra', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vi88vgrwl9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vi88vgrwl9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fxwiqusvo1t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fxwiqusvo1t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ivr78hxujh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ivr78hxujh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4wz9nvpeq1j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4wz9nvpeq1j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-umqn05k6uja').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-umqn05k6uja', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-58g416ckmoi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-58g416ckmoi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d3eie16o34b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d3eie16o34b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2qkgd3gvjf7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2qkgd3gvjf7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fuia6cw52fa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fuia6cw52fa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vihof5cb79').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vihof5cb79', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tcgrbd3z1ds').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tcgrbd3z1ds', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rckgczsk8zf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rckgczsk8zf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ktskase3jqg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ktskase3jqg', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-l5825ssdpwe"]=  window.__ectimmers["ecom-l5825ssdpwe"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-l5825ssdpwe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l5825ssdpwe', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w8589usx5i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w8589usx5i', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tgy1ti9lve8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tgy1ti9lve8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dnn803vgy9u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dnn803vgy9u', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lh3pgclglbf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lh3pgclglbf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9pz05n5r1e6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9pz05n5r1e6', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mdrjnkzx63').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mdrjnkzx63', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pthz9qn4rpf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pthz9qn4rpf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nos1k8lrkrl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nos1k8lrkrl', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x2bcct70m6j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x2bcct70m6j', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4g6edysysym').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4g6edysysym', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qy6gz5akwdf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qy6gz5akwdf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l77sfwvrfua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l77sfwvrfua', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rti372jf0c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rti372jf0c', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5kefdwn2ivw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5kefdwn2ivw', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-flkei25n2o7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-flkei25n2o7', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y7hvxqmsezr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y7hvxqmsezr', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xy0tdaerb1s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xy0tdaerb1s', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1auu0ztn6du').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1auu0ztn6du', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-an5n85n8lfo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-an5n85n8lfo', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u1yueu1pe0s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u1yueu1pe0s', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-djjf56x7a9g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-djjf56x7a9g', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tv3w4i7z0ta').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tv3w4i7z0ta', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-90mxpxb1mqq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-90mxpxb1mqq', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2z0tq92trr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2z0tq92trr', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wr1ugtc8q7m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wr1ugtc8q7m', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ddqdxjy50jj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ddqdxjy50jj', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5uj2oadj936"]=  window.__ectimmers["ecom-5uj2oadj936"] || {};
if(!this.settings||!this.$el)return;const e=this.$el,i=this.isLive,t=this.settings.loop,n=this.settings.autoplay,s=this.settings.lazyload||!1,o=this.settings.player_controls||!1,a=this.settings.pause_on_hover||!1,r=this.settings.click_to_play_pause,c=this.settings.play_on_lightbox||!1,m=1;let l=e.querySelector(".ecom-video_overlay-icon");const h=e.querySelector(".ecom-video-poster");let y;y=l&&l.querySelector(".ecom-video-icon-play");const g=e.querySelector(".ecom-element_video-iframe");s&&setTimeout(function(){b(g)},500);function b(L){let z={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver($,z).observe(L)}function u(L,z){let M={handleMouseenter:T,handleMouseleave:S,handleEnded:q};function T(){L.readyState>=m&&L.pause()}function S(){L.readyState>=m&&L.play()}function q(){x(L,M)}if(a){L.addEventListener("mouseenter",T),L.addEventListener("mouseleave",S);let P=e.querySelector(".ecom-video_link-extra");P&&P.href&&(P.addEventListener("mouseenter",T),P.addEventListener("mouseleave",S)),z||L.addEventListener("ended",q)}}function x(L,z){if(z){const{handleMouseenter:M,handleMouseleave:T,handleEnded:S}=z;let q=e.querySelector(".ecom-video_link-extra");L.removeEventListener("mouseenter",M),L.removeEventListener("mouseleave",T),L.removeEventListener("ended",S),q&&q.href&&(q.removeEventListener("mouseenter",M),q.removeEventListener("mouseleave",T))}}function $(L,z){L.forEach(function(M){if(M.isIntersecting){const T=M.target.querySelector("video source"),S=M.target.querySelector("video"),q=M.target.querySelector("iframe");if(S&&T&&(T.src=T.dataset.source,S.load(),S.addEventListener("loadeddata",function(){n&&S.play()})),q){let P=q.dataset.srcVideo;q.setAttribute("src",P)}z.unobserve(M.target)}})}let v=e.querySelector(".ecom_video"),w=e.querySelector(".ecom_iframe");r&&v.addEventListener("click",()=>{v.readyState>=m&&(v.paused?v.play():v.pause())}),n&&(l&&l.classList.remove("ecom-overlay"),y&&(y.style.display="none"),h&&(h.style.display="none")),v&&!t&&v.addEventListener("ended",function(){h&&(h.style.display="block"),l&&l.classList.add("ecom-overlay"),y&&(y.style.display="block")}),l&&l.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&v)h&&(h.style.display="none"),v.autoplay=!0,v.play(),l.classList.remove("ecom-overlay"),y.style.display="none";else if(w){let L=w.getAttribute("src");L.includes("autoplay=0")?L=L.replace("autoplay=0","autoplay=1"):L=L+"&autoplay=1",w.setAttribute("src",L),c?setTimeout(()=>{L=L.replace("autoplay=1","autoplay=0"),w.setAttribute("src",L)},100):(h&&(h.style.display="none"),l.classList.remove("ecom-overlay"),y.style.display="none")}}),v&&(i&&!h&&u(v,t),h&&h.addEventListener("click",function(){h.style.display="none",v.play(),i&&u(v,t)}),a||v.addEventListener("pause",function(){h&&(h.style.display="block"),l&&l.classList.add("ecom-overlay"),y&&(y.style.display="block")}),!o&&l&&v.addEventListener("click",function(){v.pause()})),e.querySelectorAll("[data-ec-tracking-id]").forEach(function(L){L.dataset.ecTrackingId&&L.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:L.id,tracking_id:L.dataset.ecTrackingId})},{once:!0})});const f=e.querySelector("[ecom-modal]");if(f&&this.settings.image_overlay&&c&&window.EComModal){const L=f.dataset.width,z=f.dataset.height;var k=this.id;new window.EComModal(f,{cssClass:[k,"ecom-core","ecom-core-simulator"],onOpen:function(){var M=document.querySelector(".ecom-modal."+k);if(M){const T=M.querySelector(".ecom-modal-box__content");T.classList.add("ecom-element_video-iframe");const S={width:L,height:z};Object.assign(T.style,S)}},onClose:function(){var M=document.querySelector(".ecom-modal."+k);if(M){const T=M.querySelector(".ecom-element_video-iframe iframe");T&&(T.src="")}}})}

                    });
                    
                        document.querySelectorAll('.ecom-5uj2oadj936').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5uj2oadj936', settings: {"autoplay":false,"player_controls":true,"source":"youtube"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}